module.exports = __webpack_public_path__ + "img/monitorApply.4517371d.svg";